module.exports = __webpack_public_path__ + "static/img/0544_9.87ebf93.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/0544_9.jpg
// module id = 32AQ
// module chunks = 1